// extracted by mini-css-extract-plugin
module.exports = {"optionContainer":"styles__optionContainer___2MG3L","processingIcon":"styles__processingIcon___3T6gc","spin":"styles__spin___1MHxE"};